import { Box, Stack } from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { customerSelector, getCustomerThunk } from "store/reducers/user_profiles/customerSlice";

const CustomerPanel = ({ filter, setFilter }) => {
  const dispatch = useDispatch();
  const customers = useSelector(customerSelector.selectAll);
  useEffect(() => {
    dispatch(getCustomerThunk())
  }, [])
  
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <AutoCompleteList
          items={customers}
          name={(option)=> `${option.first_name} ${option.last_name ?? ""} ${option.employee_id ? `: ${option.employee_id}`: "" }`}
          label="Filter by customers"
          setValue={(value) => {
            setFilter({
              ...filter,
              customer: value,
            });
          }}
          value={filter.customer}
        />
      </Stack>
    </Box>
  );
};

export default CustomerPanel;
